<template>
  <div class="drink-details-component d-flex align-center j-between">
    <v-btn
      class="button-param"
      color="#4CAF50"
      depressed
      @click="showUpsaleWindow"
    >
      <font-awesome-icon icon="plus" />
    </v-btn>
    <span class="status-text">{{ upsaleLabel }}</span>
    <div
      class="status d-flex align-center justify-center"
      :class="{'active': isDrinksSuggested}"
      @click="setDetailStatus"
    >
      <font-awesome-icon icon="check" />
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'DrinkDetails',
    computed: {
      ...mapState({
        isDrinksSuggested: state => state.newOrder.isDrinksSuggested,
        basket: state => state.baskets.basket,
        categories: state => state.categories.categoriesList,
        upsaleLabel: state => state.newOrder.upsaleLabelText,
      }),
      getClientName () {
        return this.basket.client ? this.basket.client.name : ''
      },
    },
    methods: {
      setDetailStatus () {
        this.$store.commit('newOrder/setDrinkDetailsStatus', true)
      },
      openDrinkCategory () {
        const drinkCategory = this.categories.find(category => category.slug === 'drinks')
        if (drinkCategory) {
          this.$store.commit('newOrder/setStep', 2)
          this.$store.commit('newOrder/togglePromotionsWindow', false)
          this.$store.commit('newOrder/setCurrentCategory', drinkCategory.id)
          this.$store.commit('newOrder/setCurrentOtherWindow', undefined)
          this.$store.commit('newOrder/setFoodWindowState', false)

          this.changeCategory(drinkCategory.id)
        }
      },
      showUpsaleWindow () {
        this.$store.commit('newOrder/setCurrentOtherWindow', 'upsales')
        this.$store.commit('newOrder/setDrinkDetailsStatus', true)
      },
      changeCategory (id) {
        this.$store.commit('newOrder/setMenuItemsLoading', true)
        this.$store
          .dispatch('categories/fetchFilialMenuSingleCategories', { id })
          .then((res) => {
            if (res.status === 200) {
              this.$store.commit(
                'newOrder/setMenuItemsList',
                res.data.data.menuItems,
              )
              this.$store.commit(
                'newOrder/setCollectionsList',
                res.data.data.collections,
              )
            }
            this.$store.commit('newOrder/setCurrentCollectionId', undefined)
            this.$store.commit('newOrder/setMenuItemsLoading', false)
          })
      },
    },
  }
</script>

<style lang="less" scoped>
  .drink-details-component {
    padding: 12px 13px;
    margin-bottom: 12px;
    background-color: #e6f2e6;
    border-radius: 10px;

    .button-param {
      font-size: 1.78em;
      line-height: 1;
      width: 2em;
      height: 2em;
      min-width: 2em !important;
      padding: 0 !important;
      margin-right: 15px;
      color: #fff;
    }

    .status {
      font-size: 1.78em;
      color: #fff;
      flex-shrink: 0;
      background-color: #c3e2c3;
      border-radius: 50%;
      width: 2em;
      height: 2em;
      cursor: pointer;
      margin-left: 15px;
      &.active {
        background-color: #4CAF50;
      }

      &-text.big {
        font-size: 1.57em;
        font-weight: bold;
      }

      svg {
       /* width: 23px;
        height: 23px;*/
        /*.fill-svg(#ffffff);*/
      }
    }
  }
</style>
